import { TableColumnDefinition } from '../table/table-column-definition'

export const ReddiHistoryTableColumnDefinitions: TableColumnDefinition[] = [
  {
    columnName: 'presentationDate',
    header: 'Presentation Date',
    sortDisabled: true,
    columnType: 'truncated-string',
    columnWidth: '130px',
    columnTextAlign: 'left',
  },
  {
    columnName: 'age',
    columnWidth: '50px',
    columnTextAlign: 'left',
    header: 'Age (Months)',
    sortDisabled: true,
    columnType: 'truncated-string',
  },
  {
    columnName: 'presenterType',
    columnWidth: '120px',
    columnTextAlign: 'left',
    header: 'Presenter',
    sortDisabled: true,
    columnType: 'truncated-string',
  },
  {
    columnName: 'impactingFactors',
    columnWidth: '170px',
    columnTextAlign: 'left',
    header: 'Considerations',
    sortDisabled: true,
    columnType: 'truncated-string',
  },
  {
    columnName: 'presenterName',
    columnWidth: '120px',
    columnTextAlign: 'left',
    header: 'Data entered by',
    sortDisabled: true,
    columnType: 'truncated-string',
  },
  {
    columnName: 'notes',
    columnWidth: '200px',
    columnTextAlign: 'left',
    header: 'Notes',
    sortDisabled: true,
    columnType: 'truncated-string',
  },
  {
    columnName: 'viewReport',
    columnWidth: '80px',
    columnTextAlign: 'left',
    header: '',
    sortDisabled: true,
    columnType: 'link',
    linkText: 'View details',
    linkKind: 'icon',
    linkColor: 'primary',
    showIcon: true,
  },
]
